import {
  topUpCard
} from "./chunk-44TNZFFP.mjs";

// src/hooks/wbk/cards/topUp.ts
import { useMutation } from "@tanstack/react-query";
var useTopUpCard = () => {
  return useMutation({
    mutationFn: topUpCard
  });
};

export {
  useTopUpCard
};
//# sourceMappingURL=chunk-5UM5J5FJ.mjs.map